import axios, {AxiosError} from 'axios';
import app from '../main';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 10000000,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Accept: '*/*',
  },
});

instance.interceptors.request.use((config) => {
  // @ts-ignore
  app.$Progress.start();
  return config;
});

instance.interceptors.response.use((response) => {
  // @ts-ignore
  app.$Progress.finish();
  return response;
}, (error: AxiosError) => {
  // @ts-ignore
  app.$Progress.fail();
  return Promise.reject(error);
});
export default instance;
